import SEOMetadata from '@/components/SEOMetadata';
import React, { Suspense, useEffect } from 'react';
import StyledDevelopers from './styles/DeveloperPageStyles';
import GlyphHeader from '@/components/landing/developers/GlyphHeader'
import QuickStartSteps from '@/components/landing/developers/QuickStartSteps';
import { useIdlePrefetch } from '@/hooks/useIdlePrefetch';

const loadQuickStartCode = () => import('@/components/landing/developers/QuickStartCode');
const QuickStartCode = React.lazy(loadQuickStartCode);
const loadDevFeaturesMasonGrid = () => import('@/components/landing/developers/DevFeaturesMasonGrid');
const DevFeaturesMasonGrid = React.lazy(loadDevFeaturesMasonGrid);
const loadMCPFeatures = () => import('@/components/landing/developers/MCPFeatures');
const MCPFeatures = React.lazy(loadMCPFeatures);
const loadEnterpriseGrid = () => import('@/components/landing/developers/EnterpriseGrid');
const EnterpriseGrid = React.lazy(loadEnterpriseGrid);
const loadCloudSupport = () => import('@/components/landing/developers/CloudSupport');
const CloudSupport = React.lazy(loadCloudSupport);
const loadSecuritySupport = () => import('@/components/landing/developers/SecuritySupport');
const SecuritySupport = React.lazy(loadSecuritySupport);
const loadDocumentationBreakout = () => import('@/components/landing/developers/DocumentationBreakout');
const DocumentationBreakout = React.lazy(loadDocumentationBreakout);
const loadBlogs = () => import('@/components/landing/home/BlogCards');
const Blogs = React.lazy(loadBlogs);
const loadPricingTable = () => import('@/components/landing/PricingTable');
const PricingTable = React.lazy(loadPricingTable);
const loadGetStarted = () => import('@/components/landing/GetStarted');
const GetStarted = React.lazy(loadGetStarted);
const loadFooter = () => import('@/components/landing/Footer');
const Footer = React.lazy(loadFooter);


const DevelopersPage: React.FC = () => {
  useIdlePrefetch([loadQuickStartCode, loadDevFeaturesMasonGrid, loadMCPFeatures, loadEnterpriseGrid, loadCloudSupport, loadSecuritySupport, loadDocumentationBreakout, loadBlogs, loadPricingTable, loadGetStarted, loadFooter]);

  useEffect(() => { window.track('developers_page_visited') }, []);

  return (
    <>
      <SEOMetadata
        title="Financial Data API for Developers — Python, TypeScript & MCP SDK"
        description="A Python financial data API and market data SDK for stock market data, algorithmic trading, quantitative research, and backtesting."
        canonicalUrl="https://axionquant.com/developers"
      />
      <StyledDevelopers>

        <GlyphHeader/>
        <QuickStartSteps/>

        <Suspense fallback={null}>
        <QuickStartCode/>
        <DevFeaturesMasonGrid/>
        <MCPFeatures/>
        <EnterpriseGrid/>
        <CloudSupport/>
        <SecuritySupport/>
        <DocumentationBreakout/>

        <div className="blogs">
          <Blogs/>
        </div>

        <PricingTable />
        <GetStarted />
        <Footer />
        </Suspense>
      </StyledDevelopers>
    </>
  );
};

export default DevelopersPage;

